import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAdmin } from '../../context/AdminContext';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Package, Users, Mail, Eye } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Dashboard = () => {
  const { getAuthHeaders } = useAdmin();
  const [stats, setStats] = useState({
    products: 0,
    parceiros: 0,
    messages: 0
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const statsRes = await axios.get(`${API}/admin/stats`, { headers: getAuthHeaders() });
      setStats({
        products: statsRes.data.products || 0,
        parceiros: statsRes.data.partners || 0,
        messages: statsRes.data.messages || 0
      });
    } catch (error) {
      console.error('Erro ao carregar estatísticas:', error);
    }
  };

  const statCards = [
    {
      title: 'Produtos',
      value: stats.products,
      icon: Package,
      color: 'text-blue-500'
    },
    {
      title: 'Parceiros',
      value: stats.parceiros,
      icon: Users,
      color: 'text-green-500'
    },
    {
      title: 'Mensagens',
      value: stats.messages,
      icon: Mail,
      color: 'text-orange-500'
    }
  ];

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">Dashboard</h1>
        <p className="text-white/60">Visão geral do sistema</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <Card key={stat.title} className="bg-gradient-to-br from-[#3a2f24] to-[#4a3f2e] border-[#cc8b3a]/20">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-white/80">
                  {stat.title}
                </CardTitle>
                <Icon className={`w-4 h-4 ${stat.color}`} />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-white">{stat.value}</div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Quick Actions */}
      <Card className="bg-gradient-to-br from-[#3a2f24] to-[#4a3f2e] border-[#cc8b3a]/20">
        <CardHeader>
          <CardTitle className="text-white">Ações Rápidas</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-3 p-3 rounded-lg bg-black hover:bg-gradient-to-br from-[#3a2f24] to-[#4a3f2e] transition-colors text-white"
          >
            <Eye className="w-5 h-5 text-[#cc8b3a]" />
            <div>
              <p className="font-medium">Ver Site Público</p>
              <p className="text-sm text-white/60">Visualizar como os visitantes veem</p>
            </div>
          </a>
        </CardContent>
      </Card>
    </div>
  );
};

export default Dashboard;
